import { inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map } from 'rxjs/operators'
import { ContextMenuAction, ContextMenuItemEvent } from '@core/models/context-menu.models'
import { clickContextMenuItem, clickOnContextMenuItem } from '@core/store/actions/context-menu.actions'
import { Action } from '@ngrx/store'
import { fetchMetricDetail } from '@features/metric-detail/store/actions/metric-detail.actions'
import { fetchRanking } from '@features/rankings/store/actions/ranking.actions'
import { MetricItemContextMenu } from '@core/enums/metric-context-menu.enum'

type ActionCreator = (props: { payload: ContextMenuItemEvent }) => Action
const contextMenuActionMap: Record<ContextMenuAction, ActionCreator> = {
  MTR_METRIC_DETAIL: fetchMetricDetail,
  MTR_RANKINGS: fetchRanking
}

const menuItemMap: Record<MetricItemContextMenu, ActionCreator> = {
  [MetricItemContextMenu.MetricDetails]: fetchMetricDetail,
  [MetricItemContextMenu.Rankings]: fetchRanking
}

@Injectable()
export class ContextMenuEffects {
  private readonly _actions$: Actions = inject(Actions)

  clickContextMenuItem$ = createEffect(() =>
    this._actions$.pipe(
      ofType(clickContextMenuItem),
      map(({ type: _type, menuItem: { action }, ...payload }) => contextMenuActionMap[action]({ payload }))
    )
  )

  clickOnContextMenuItem$ = createEffect(() =>
    this._actions$.pipe(
      ofType(clickOnContextMenuItem),
      map(({ type: _type, menuItem, ...payload }) => menuItemMap[menuItem]({ payload }))
    )
  )
}
